import * as UUID from '@zenlayer/util/esm/uuid.js';
import zxcvbn from 'zxcvbn';
/**
 * 生成唯一的uuid,并且可通过传入数字截取对应长度
 * @function
 * @param {number}  可选，需要截取的长度
 * @return {string}
 * @example
 * const uuid = generateUuid();
 * 输出类似 'f47ac10b-58cc-4372-a567-0e02b2c3d479'
 */

export var generateUuid = function generateUuid(num) {
  return UUID.generateUuid().substring(0, num);
};
/**
 * 检查密码强度
 * ```ts
 * const score = checkPasswordStrength("123456789@.")
 * >>>
 * 1 // score would be 0-4
 * ```
 * score:
 * * 0: too guessable: risky password. (guesses < 10^3)
 * * 1: very guessable: protection from throttled online attacks. (guesses < 10^6)
 * * 2: somewhat guessable: protection from unthrottled online attacks. (guesses < 10^8)
 * * 3: safely unguessable: moderate protection from offline slow-hash scenario. (guesses < 10^10)
 * * 4: very unguessable: strong protection from offline slow-hash scenario. (guesses >= 10^10)
 */

export var checkPasswordStrength = function checkPasswordStrength(password) {
  var _zxcvbn;

  return ((_zxcvbn = zxcvbn(password)) === null || _zxcvbn === void 0 ? void 0 : _zxcvbn.score) || 0;
};